module.exports = __webpack_public_path__ + "static/ABONNEMENT_6-701369bd5c767a4b6612349db0cfd0e2.png";